<fieldset class="fieldset w-full">
  <legend class="fieldset-legend">{{ label }}</legend>
  <input
    type="text"
    class="input w-full"
    [value]="value"
    (input)="handleInput($event)"
    (blur)="onTouched()"
  />
  <p class="label-text wrap-break-word w-full text-gray-400">{{ helper || '' }}</p>
</fieldset>
